import axios from "axios";

/** Live backend used when REACT_APP_BACKEND_API_URL is unset. Set that env to `mock` to use local mocks. */
const TESTING_BACKEND_URL = "https://testing.lite.tradelyft.in";

// If using mocks, baseURL should be empty so setupProxy can intercept.
// If using real API, use the full backend origin (no trailing slash).
const getBaseURL = () => {
  const raw = String(process.env.REACT_APP_BACKEND_API_URL ?? "").trim();
  const url = raw.replace(/\/+$/, "");

  if (!url || url.toLowerCase() === "mock" || url === "/api" || url.startsWith("/api/") || url.startsWith("/")) {
    // Empty / mock → same-origin (CRA proxy or nginx). For local testing, default to live BE.
    if (!url) return TESTING_BACKEND_URL;
    return "";
  }

  return url;
};

const axiosInstance = axios.create({
    baseURL: getBaseURL()
});

export function setUpInterceptors(auth, logout, tryTokenRefresh) {

    axiosInstance.interceptors.request.use(
        (config) => {
            const access_token = localStorage.getItem("access_token");

            if (access_token) {
                config.headers.Authorization = `Bearer ${access_token}`;
            }
    
            return config;
        },
        (error) => {
            return Promise.reject(error);
        }
    );

    axiosInstance.interceptors.response.use(
        (response) => {
            return response;
        },
        async (error) => {
            const originalRequest = error.config;

            if (error.response?.status === 401 && !originalRequest._retry && !originalRequest.url?.includes("token/refresh")) {
                originalRequest._retry = true;

                try {
                    await tryTokenRefresh();

                    const access_token = localStorage.getItem("access_token");
                    originalRequest.headers.Authorization = `Bearer ${access_token}`;

                    return axiosInstance(originalRequest);
                } catch (refreshError) {
                    logout();
                    return Promise.reject(refreshError);
                }
                
            }
    
            return Promise.reject(error);
        }
    );
    
}

export default axiosInstance;
